import UISection from 'UIComponents/section/UISection';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TitleDetailWrapper = styled.div.withConfig({
  displayName: "LogEventDetailField__TitleDetailWrapper",
  componentId: "sc-1j1zurz-0"
})(["font-weight:", ";"], ({
  theme
}) => theme.typography['heading-200'].fontWeight);
const LogEventDetailField = ({
  header,
  children
}) => {
  return /*#__PURE__*/_jsxs(UISection, {
    children: [/*#__PURE__*/_jsx(TitleDetailWrapper, {
      children: header
    }), children]
  });
};
export default LogEventDetailField;